import "./people_gallery.css";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    let current = 0;

    const gallery = document.getElementById("people_gallery");
    const items = document.querySelectorAll(".people_gallery_item");
    const left = document.getElementById("people_gallery_navigation_left");
    const right = document.getElementById("people_gallery_navigation_right");
    const total = document.getElementById("people_gallery_navigation_total");

    if (!gallery) return;

    const pages =
      window.innerWidth >= 992 ? Math.ceil(items.length / 3) : items.length;

    const scroll =
      window.innerWidth >= 992
        ? items[0].clientWidth * 3 + 60
        : items[0].clientWidth + 20;

    total.innerHTML = pages;

    const pointer = document.getElementById(
      "people_gallery_navigation_current",
    );

    const update = () => {
      gallery.scrollLeft = current * scroll;
      if (window.innerWidth >= 992) {
        pointer.innerHTML = current + 1;
      }
    };

    left.addEventListener("click", () => {
      current = (current - 1) % pages;
      update();
    });

    right.addEventListener("click", () => {
      current = (current + 1) % pages;
      update();
    });

    gallery.addEventListener("scroll", () => {
      if (window.innerWidth < 992) {
        current = Math.round(gallery.scrollLeft / scroll);
        pointer.innerHTML = current + 1;
      }
    });
  },
  false,
);
